<template>
  <v-col>
    <v-row :class="setSize">
      <v-col
        v-if="!isSub"
        class="header-text"
        cols="2">
        {{ element.header || element.label }}
      </v-col>
      <v-col
        v-if="!isSub"
        cols="1">
        <v-switch
          v-model="disableBtn"
          class="custom-switch" />
      </v-col>
      <v-col
        v-if="isSub"
        class="label-text pa-0"
        cols="2">
        {{ element.label }}
      </v-col>
      <component
        :is="isComponent"
        v-bind="element"
        :disable-group="disableEvent"
        :value="value"
        @input="handleComponentInput" />
    </v-row>
  </v-col>
</template>

<script>

export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    element: {
      type: Object,
      required: true
    },
    disableGroup: {
      type: Boolean,
      default: false
    },
    isSub: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      disableBtn: false,
      disableEvent: false
    }
  },
  computed: {
    isComponent () {
      const componentName = this.element.component
      return () => import(`./${componentName}.vue`)
    },
    setSize () {
      let style = ''
      if (this.element.component !== 'SubComponents') {
        if (this.isSub) {
          style = 'sub-row'
        } else {
          style = 'main-row'
        }
      }

      return style
    }
  },
  watch: {
    disableBtn () {
      this.disableEvent = this.disableBtn
      this.$emit('disable-trigger', this.disableEvent)
    },
    disableGroup () {
      this.disableEvent = this.disableGroup
    }
  },
  mounted () {
    this.disableBtn = this.disableGroup
  },
  methods: {
    handleComponentInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style>
div.row.main-row {
  height: 80px;
}
div.row.sub-row {
  height: 50px;
  padding: 0;
}
.header-text {
  font-size: 16px;
}
.label-text {
  font-size: 16px;
}
</style>>
